import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { FilePreviewFileInfo } from '../types';
import Player from 'xgplayer';
import { v1 as uuid } from 'uuid';

function VideoPreview(props: { value: FilePreviewFileInfo }) {
  const { value } = props;
  const playInstance = useRef<Player>();
  const containerId = useMemo(() => {
    if (value?.url) {
      return `xgplayer-${uuid()}`;
    }
  }, [value?.url]);

  const onPreventContextMenu = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  useEffect(() => {
    if (containerId) {
      playInstance.current = new Player({
        width: '100%',
        height: '100%',
        id: containerId,
        url: value?.url,
        autoplay: true,
        volume: 0.2,
        ignores: ['cssFullscreen', 'playbackRate'],
        controls: true
      });
    }

    return () => {
      (async () => {
        await playInstance.current?.destroy();
      })();
    };
  }, [containerId]);

  return (
    <div className="asset-management-file-preview-video-content" onContextMenu={onPreventContextMenu}>
      <div id={containerId} />
    </div>
  );
}

export default VideoPreview;
